var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomIcon = void 0;
var CustomIcon_1 = __importDefault(require("./CustomIcon"));
exports.CustomIcon = CustomIcon_1.default;
exports.default = CustomIcon_1.default;
//# sourceMappingURL=index.js.map